


























import { Component } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import OpportunityStatus from '@/models/Opportunities/OpportunityStatus';

@Component({ name: 'OpportunityStatusSet' })
export default class extends GiganautVueDialog {
  oppStatus = OpportunityStatus;
  menu = false;

  get opportunity() { return OpportunityDetailsModule.opportunity; }

  async setStatus(status: OpportunityStatus) {
    if (!this.opportunity) return;
    await OpportunityDetailsModule.setStatus({
      id: this.opportunity.id,
      status,
      updatedAt: this.opportunity.updatedAt,
    });
  }
}
